import apiClient from './base/apiClient'
import { Notification } from '../types/notification'

export interface NotificationListResponse {
  notifications: Notification[]
}

export interface MarkAsReadResponse {
  message: string
}

export const notificationApi = {
  getNotifications: async (): Promise<NotificationListResponse> => {
    const response = await apiClient.get<NotificationListResponse>(
      '/notifications'
    )
    return response.data
  },

  markAsRead: async (id: string): Promise<MarkAsReadResponse> => {
    const response = await apiClient.post<MarkAsReadResponse>(
      `/notifications/${id}/read`
    )
    return response.data
  },

  markAllAsRead: async (): Promise<MarkAsReadResponse> => {
    const response = await apiClient.post<MarkAsReadResponse>(
      '/notifications/read-all'
    )
    return response.data
  },
}
